import React, {useEffect, useState} from "react";
import {NextPage} from "next";
import SuccessStory from "../src/components/successStory/SuccessStory";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import WaveLayout from "../src/layouts/WaweLayout";
import SubpageHeroArea from "../src/components/subpageHeroArea/SubpageHeroArea";
import SuccessStoriesHeroAreaContent from "../src/components/subpageHeroArea/SuccessStoriesHeroArea";
import ReadTheStoriesButton from "../src/components/heroAreaButtons/ReadTheStoriesButton";
import SendStoryButton from "../src/components/heroAreaButtons/SendStory";
import styled from "styled-components";
import AboutPinkStories from "../src/components/successStory/AboutPinkStories";
import {deviceMax} from "../styles/device";
import Colors from "../src/constants/Colors";
import {NavigationURLs} from "../src/functions/NavigationFunctions";
import axios from "axios";
import Image from "next/image";

const BasariHikayeleri = () => {

    const [successStoriesItem, setSuccessStoriesItem] = useState([]);

    useEffect(() => {
        const fetchSuccessStories = async () => {
            const {data} = await axios.get(`${process.env.NEXT_PUBLIC_AIRTABLE_SUCCESS_STORY_PAGES_URL}`, {
                headers: {
                    Authorization: `Bearer ${process.env.NEXT_PUBLIC_AIRTABLE_TOKEN_SUCCESS_STORY_PAGES}`,
                    'Content-Type': 'application/json'
                }
            });
            setSuccessStoriesItem(data.records);
        }
        fetchSuccessStories().then();

    }, []);

    const breadcrumbItemsBasariHikayeleri = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Başarı Hikayeleri'}
    ];

    return (
        <React.Fragment>
            <HtmlHead pageTitle={'Başarı Hikayeleri - Pembe Panjur'} description={'Pembe Panjur başarı hikayeleri ile ilgili detaylara sayfamızdan ulaşabilirsiniz.'}/>

            <WaveLayout
                bodyBackgroundColor={false}
                backgroundColor={'linear-gradient(180deg, #D2147D 0%, #752280 100%)'}
                loginButtonText={false}
                hamburgerMenuType={'white'}
                backgroundType={'linear'}
                homeButton={true}
                extraChildren={
                    <React.Fragment>
                        <SuccessStoryContainer>
                            <AboutPinkStories title={'Pembe Panjur\'a hikayeni yaz ödülünü al!'} breadcrumb={breadcrumbItemsBasariHikayeleri}/>
                            {successStoriesItem.map((item: any, index: number) => {
                                return (
                                    Object.keys(item.fields).length > 0 ?
                                        <SuccessStory id={index === 0 ? 'view-position' : undefined}
                                            key={index} image={item.fields.image}
                                                      title={item.fields.page_title}
                                                      date={item.fields.date}
                                                      content={item.fields.content}
                                                      link={`/basari-hikayeleri/${item.fields.page_url_name}`}
                                        /> : null
                                )
                            })}
                        </SuccessStoryContainer>
                    </React.Fragment>
                }
            >
                <SubpageHeroArea>
                    <SuccessStoriesHeroAreaContent/>
                    <div className="img-wrapper">
                        <Image loading={'lazy'} width={1508}
                               height={1022}
                               sizes={'100vw'}
                               style={{width: '100%', height: 'auto'}}
                               src={`/next/assets/images/basari_hikayeleri/success-stories-hero-area-tiny.png`}
                               alt={'Pembe Panjur'} title={'Pembe Panjur'}
                               className={'success-stories-desktop-img'}/>
                    </div>
                    <ReadTheStoriesButton backgroundColor={'#fff'} textColor={false}/>
                    <SendStoryButton backgroundColor={'#D2147D'} textColor={true}
                                     url={NavigationURLs.successStorySend}/>
                    <div style={{height: 14}}></div>
                </SubpageHeroArea>

            </WaveLayout>


        </React.Fragment>
    )
}

const SuccessStoryContainer = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding-left: calc(50vw - 575px);
  padding-right: calc(50vw - 575px);
  padding-top: 47px;

  @media ${deviceMax.tablet} {
    padding-top: 32px;
    background-color: ${Colors.white};
  }
`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default BasariHikayeleri;
